<template>
	<div>
		<ul class="steps">
			<li v-for="(step, index) in steps" :key="index" :class="verifyStep(index, value, steps)">
				<v-layout justify-space-between>
					<span class="step-icon">
						<svg>
							<image v-if="verifyStep(index, value, steps) === 'active'" xlink:href="../../assets/icons/more-horizontal.svg"/>
							<image v-else-if="verifyStep(index, value, steps) === 'finished'" xlink:href="../../assets/icons/check.svg"/>
							<image v-else xlink:href="../../assets/icons/x.svg"/>
						</svg>
					</span>
					<v-spacer />
					<p class="step-description">{{step.description}}</p>
					<v-spacer />
				</v-layout>
			</li>
		</ul>
		<slot v-if="value < 0" name="step0" />
		<slot v-else :name="'step' + (value + 1)" />
	</div>
</template>
<script>
import closeIcon from '../../assets/icons/x.svg';
import checkIcon from '../../assets/icons/check.svg';
export default {
  name: 'steps',
  props: {
    value: Number,
    steps: {
      Type: Array,
      Required: true
    }
  },
  components: {
    closeIcon,
    checkIcon
  },
  data() {
    return {};
  },
  methods: {
    verifyStep(index, currentStep, steps) {
      if (currentStep >= steps.length - 1) return 'finished';
      if (index === currentStep) return 'active';
      if (index <= currentStep) return 'finished';
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/breakpoint';
$colorBase: #cccccc;
$colorActive: #0093f0;
$colorFinished: #4bb629;

.steps {
  padding: 0;
  display: flex;
  width: 100%;

  li {
    flex-grow: 1;
    height: 60px;
    list-style-type: none;
    padding: 5px 5px 5px 20px;
    line-height: 50px;
    border-right: 5px solid white;
    position: relative;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;

    @include breakpoint(mobile) {
      height: 40px;
    }

    &:first-child > .step-icon {
      left: 18px;
    }
    .step-icon {
      position: absolute;
      top: 18px;
      left: 28px;
      display: inline-block;
      width: 28px;
      height: 28px;
      background: #ffffff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 20px;
        height: 20px;
        image {
          display: flex;
          width: 100%;
          height: 100%;
        }
      }

      @include breakpoint(mobile) {
        top: 10px;
        left: 18px;
        width: 24px;
        height: 24px;
      }
    }

    p {
      padding-left: 40px;
      @include breakpoint(mobile) {
        padding-left: 20px;
        // display: none;
      }
    }
    .step-description {
      @include breakpoint(mobile) {
        display: none;
      }
    }

    &:first-child > p {
      padding-left: 30px;
    }

    &:last-child.finished {
      @include breakpoint(mobile) {
        width: 50%;
        .step-description {
          display: initial;
          line-height: 30px;
        }
      }
    }

    &:first-child {
      border-radius: 4px;
    }

    &:last-child {
      border-radius: 4px;
      border-right-width: 0px;
    }

    &:last-child::after {
      border: none;
    }

    &:nth-child(n + 2)::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      border-left: 15px solid white; /* width: arrow width, color: background of document */
      border-top: 20px solid transparent; /* width: half height */
      border-bottom: 20px solid transparent; /* width: half height */
      width: 0;
      height: 0;
      content: ' ';
    }

    &::after {
      z-index: 1;
      position: absolute;
      top: 0;
      right: -15px;
      display: block;
      border-left: 15px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      width: 0;
      height: 0;
      content: ' ';
    }
  }
}

/* Completed */
.steps li {
  background-color: $colorBase;
}
.steps li::after {
  border-left-color: $colorBase;
}

/* Current */
.steps li.active {
  background-color: $colorActive;
  @include breakpoint(mobile) {
    width: 50%;
    .step-description {
      display: initial;
      line-height: 30px;
    }
  }
}
.steps li.active::after {
  border-left-color: $colorActive;
}

/* Finished */
.steps li.finished {
  background-color: $colorFinished;
}
.steps li.finished::after {
  border-left-color: $colorFinished;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Steps.vue